// ** Logo
import logo1 from '@src/assets/images/icons/zainLogo.svg'
import RedCubeAnimation from '../../../RedCubeAnimation'

const SpinnerComponent = () => {
  return (
    <div className='d-flex align-items-center justify-content-center flex-column fallback-spinner vh-100'>
      {/* <img className='fallback-logo' src={logo} alt='logo' width={'15%'}/>
      <div className='loading'>
        <div className='effect-1 effects'></div>
        <div className='effect-2 effects'></div>
        <div className='effect-3 effects'></div>
      </div> */}
      <RedCubeAnimation />
    </div>
  )
}

export default SpinnerComponent
